import { Children, cloneElement } from 'react';

export const applyPropsToChildren = (element, props) =>
  !element.props
    ? element
    : cloneElement(
        element,
        props,
        Children.map(element.props.children, (child) =>
          applyPropsToChildren(child, props)
        )
      );
